function extractText(html) {
    // 1. Create a temporary element
    const tempDiv = document.createElement("div");

    // 2. Set the HTML content
    tempDiv.innerHTML = html;

    // 3. Extract text (textContent or innerText)
    return tempDiv.textContent || tempDiv.innerText || "";
}

export default extractText
